import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { HomefieldIconLibraryModule, HomefieldIconsLibraryService, homefieldIconAlertErrorOutlined, homefieldIconSignCancel } from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { SnackbarComponent } from './snackbar.component';

@NgModule({
	declarations: [SnackbarComponent],
	imports: [
		CommonModule,
		HomefieldIconLibraryModule
	],
	exports: [
		SnackbarComponent
	],
	schemas: [
		CUSTOM_ELEMENTS_SCHEMA,
		NO_ERRORS_SCHEMA
	]
})
export class SnackbarModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([homefieldIconAlertErrorOutlined, homefieldIconSignCancel]);
	}
}
